import { Stack } from 'expo-router';
import React from 'react';

export default function TellingLayout() {
  return (
    <Stack>
      <Stack.Screen name="index" />
      <Stack.Screen name="[battlePlanId]" options={{ headerShown: false }} />
    </Stack>
  );
} 